import { FC } from "react";
import SubmittedDocumentsSection from "../../IRB/IRBSubmission/CreateIRBSubmission/IRBSubmission/SubmittedDocumentsSection";

const ECSubmissionECAR: FC = (): JSX.Element => {
  const documents = "documents";

  return (
    <SubmittedDocumentsSection
      fieldName={documents}
      labelText="2.1  Documents Submitted - EC"
    />
  );
};

export default ECSubmissionECAR;
